module.exports = __webpack_public_path__ + "static/media/cora.b48dcf4a.jpg";